// extracted by mini-css-extract-plugin
export default {"saveAsDefaultForm":"save-as-default-form_saveAsDefaultForm__60db2"};